import { render, staticRenderFns } from "./AnalisiIniziale_Tab2.vue?vue&type=template&id=c1c69746&scoped=true&"
import script from "./AnalisiIniziale_Tab2.vue?vue&type=script&lang=js&"
export * from "./AnalisiIniziale_Tab2.vue?vue&type=script&lang=js&"
import style0 from "./AnalisiIniziale_Tab2.vue?vue&type=style&index=0&id=c1c69746&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c69746",
  null
  
)

export default component.exports